import { useTranslate } from 'react-admin';
import { ConfigurationSettingsFields } from '@/components/global/forms/ConfigurationSettingsFields.jsx';
import { optionalCurrency, optionalDigits } from '@/components/retailChain/validators/retailChainValidators.js';

const LOCKED_SERVICE_COMPANY_NAME = 'MaasLoop Service';

export const BrandConfiguration = () => {
    const translate = useTranslate();
    const fieldLabel = key => translate(`resources.brand.fields.${key}`);

    return (
        <ConfigurationSettingsFields
            title={translate('resources.brand.labels.configuration')}
            fieldLabel={fieldLabel}
            validateCurrency={optionalCurrency(translate('resources.brand.validation.currency'))}
            validateDigits={optionalDigits(translate('resources.brand.validation.digits'))}
            limitTitle={translate('resources.brand.labels.discountLimits')}
            valueTitle={translate('resources.brand.labels.discountValues')}
            limitLabelKey='resources.brand.labels.discountLimit'
            valueLabelKey='resources.brand.labels.discountValue'
            serviceCompanyProps={{
                requireSelection: false,
                requireDefault: false,
                lockedCompanyName: LOCKED_SERVICE_COMPANY_NAME,
            }}
        />
    );
};

BrandConfiguration.propTypes = {};
